/* istanbul ignore file */
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';
import { OktaAuthStateService } from '@okta/okta-angular';
import { PGHOktaService } from './pghokta.service';
import { HardwareTestResult } from 'src/app/shared/device/phone-device/hardware-test-result';

@Injectable({
  providedIn: 'root'
})

export class MobileDeviceService {
  middlewareUrl: string;
  servicePath: string;
  accountPath: string;
  private accessToken: string;
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public oktaAuth: OktaAuthStateService,
    private pghOktaService: PGHOktaService
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.servicePath = this.preInitSettingsService.getSettings().middleWare.servicePath;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    this.accessToken = this.pghOktaService.getAccessToken();
  }

  getMobileDevicesSummary(contractId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.accessToken}`
      }),
    };
    return this.http.get<any>(`${this.middlewareUrl}${this.servicePath}enrolleddevices?contractId=${contractId}`, httpOptions);
  }

  getHardwareTestResults(imei: string): Observable<HardwareTestResult> {
    return this.http.get<HardwareTestResult>(`${this.middlewareUrl}${this.accountPath}hardware-tests/${imei}`);
  }
}
